export default __webpack_public_path__ + "static/media/Human6.a3474cfb.png";